import React from "react";
import { compose } from "recompose";
import { defineMessages, useIntl } from "react-intl";
import EnhanceCartItemQuantityForm from "theme/modules/Cart/CartItem/CartItemQuantityForm/EnhanceCartItemQuantityForm";
import EnhanceRemoveItemCart from "theme/modules/Cart/CartItem/CartItemRemoveForm/EnhanceRemoveItemCart";
import UpdateCartItemQtyMutation from "theme/modules/Cart/CartItem/CartItemQuantityForm/UpdateCartItemQtyMutation.gql";
import RemoveCartItemMutation from "theme/modules/Cart/CartItem/CartItemRemoveForm/RemoveCartItemMutation.gql";
import Image from "theme/components/atoms/Image";
import Price from "theme/components/atoms/Typography/Price";
import IconButton from "theme/components/atoms/Button/IconButton";
import CartItemStatus from "theme/modules/Cart/CartItem/CartItemStatus";
import CartItemQuantityForm from "theme/modules/Cart/CartItem/CartItemQuantityForm";
import TrackingLink from "theme/components/atoms/Typography/Link/TrackingLink";
import { graphql } from "react-apollo";
import CustomerBillingCountryQuery from "theme/components/atoms/Typography/Price/CustomerBillingCountryQuery.gql";

const messages = defineMessages({
  removeItem: {
    id: "modules.Cart.MiniCart.MiniCartContent.MiniCartItem.removeItem",
    defaultMessage: "Remove",
  },
  optionLabel: {
    id: "modules.Cart.MiniCart.MiniCartContent.MiniCartItem.optionLabel",
    defaultMessage: "{optionName}: {optionValue}",
  },
});

const MiniCartItem = ({
  item,
  onRefreshQuantity,
  refreshQuantityStatus,
  removeItemStatus,
  removeItem,
  cart,
  customerBillingCountry,
}) => {
  const intl = useIntl();
  return (
    <div className="mini-cart-item">
      <div className="mini-cart-item__image">
        {item.product?.imageUrl ? (
          <Image
            src={item.product.imageUrl}
            alt={item.name}
            format="small"
            appearance="full"
          />
        ) : null}
      </div>
      <div className="mini-cart-item__content">
        <div className="mini-cart-item__name">
          {item.product ? (
            <TrackingLink
              to={item.product.path}
              eventName="Product Clicked"
              eventPayload={{
                sku: item.sku,
                name: item.name,
              }}
            >
              {item.name}
            </TrackingLink>
          ) : (
            item.name
          )}
        </div>
        {item.options.length > 0 && (
          <div className="mini-cart-item__options">
            {item.options.map((option) => (
              <div className="mini-cart-item__option" key={option.id}>
                <span className="mini-cart-item__option-label">
                  {option.label}
                </span>
                <span className="mini-cart-item__option-value">
                  {option.value}
                </span>
              </div>
            ))}
          </div>
        )}
        <div className="mini-cart-item__details">
          <div className="mini-cart-item__quantity">
            <CartItemQuantityForm
              quantity={item.qty}
              item_id={item.item_id}
              disabled={removeItemStatus.commandPending}
              onRefreshQuantity={onRefreshQuantity}
              refreshQuantityPending={refreshQuantityStatus.commandPending}
              appearance={"small"}
            />
          </div>
          <div className="mini-cart-item__remove">
            <IconButton
              onClick={removeItem}
              iconType="svg"
              icon="trashcart"
              title={intl.formatMessage(messages.removeItem)}
              state={
                removeItemStatus.commandPending
                  ? "pending"
                  : refreshQuantityStatus.commandPending
                  ? "disabled"
                  : undefined
              }
              onDisableClick={() => {}}
            />
          </div>
          <div className="mini-cart-item__price">
            <Price price={item.priceInfo.rowTotalExclTax} />
          </div>
        </div>
        <CartItemStatus
          refreshQuantityStatus={refreshQuantityStatus}
          removeItemStatus={removeItemStatus}
        />
      </div>
    </div>
  );
};

export default compose(
  graphql(CustomerBillingCountryQuery, { name: "customerBillingCountry" }),
  EnhanceRemoveItemCart({ RemoveCartItemMutation }),
  EnhanceCartItemQuantityForm({ UpdateCartItemQtyMutation })
)(MiniCartItem);
